import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Entity} from '../entity/entity';
import {EntityHeader} from '../entity/entity-header';
import {AwardProbability} from '../opportunity/award-probability';
import {Opportunity} from '../opportunity/opportunity';
import {GoogleService} from './google-service';
import {PersonLoginService} from './person-login-service';
import {OpportunitySearchCriteria} from '../opportunity/opportunity-search-criteria';
import {BrandID} from "../enums/brand-id";

@Service()
export class OpportunityService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private readonly personLoginService = inject(PersonLoginService);


  private urlBase = environment.serviceUrl;

  public searchHeaders(criteria: OpportunitySearchCriteria): Observable<EntityHeader[]> {
    let url = this.urlBase + 'opportunity/search';
    let body = JSON.stringify(criteria);
    return this.http.post<EntityHeader[]>(url, body, {headers: this.getPostHeaders()});
  }

  public getOpportunity(id: string, revision: number): Observable<Opportunity> {
    let url = this.urlBase + 'opportunity/' + id + '/' + revision;
    return this.http.get<Opportunity>(url, {headers: this.getRequestHeaders()});
  }

  public getAssociatedQuote(associatedQuoteId: string, associatedQuoteRevision: number): Observable<Entity> {
    let url = this.urlBase + 'opportunity/associatedQuote/' + associatedQuoteId + '/' + associatedQuoteRevision;
    return this.http.get<Entity>(url, {headers: this.getRequestHeaders()});
  }

  public getAssociatedQuotes(opportunityId: string, opportunityRevision: number): Observable<Entity[]> {
    let url = this.urlBase + 'opportunity/associatedQuotes/' + opportunityId + '/' + opportunityRevision;
    return this.http.get<Entity[]>(url, {headers: this.getRequestHeaders()});
  }

  public getAllAwardProbabilities(brandID: BrandID): Observable<AwardProbability[]> {
    let url = this.urlBase + 'opportunity/awardProbabilities/' + brandID;
    return this.http.get<AwardProbability[]>(url, {headers: this.getRequestHeaders()});
  }

  public save(opportunity: Opportunity): Observable<Opportunity> {
    let url = this.urlBase + 'opportunity/save';
    let body = JSON.stringify(opportunity);
    return this.http.post<Opportunity>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
